(function(){
  var STORAGE_KEY = 'penombreViewedProducts';
  var MAX_STORED = 12;

  function getHandles(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e){ return []; }
  }

  function trackHandle(handle){
    if(!handle) return;
    try{
      var list = getHandles().filter(function(h){ return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch(e){}
  }
  window.lumaTrackRecentlyViewed = trackHandle;

  function money(cents){
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function imageUrl(src, width){
    if(!src) return '';
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  function buildCard(p){
    var img = imageUrl(p.featured_image, 700);
    var priceHtml = p.price_varies ? 'Dès ' + money(p.price_min) : money(p.price);
    var a = document.createElement('a');
    a.href = p.url;
    a.className = 'product-card';
    a.style.display = 'block';
    a.innerHTML =
      '<div style="aspect-ratio:1/1;border-radius:var(--radius-md);overflow:hidden;background:var(--luma-stone);margin-bottom:var(--space-3)">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover">' : '') +
      '</div>' +
      '<h3 class="h4" style="font-weight:500;margin-bottom:4px">' + p.title + '</h3>' +
      '<p class="text-muted">' + priceHtml + '</p>';
    return a;
  }

  function init(){
    var root = document.querySelector('[data-recently-viewed]');
    if(!root) return;
    var grid = root.querySelector('[data-recently-viewed-grid]');
    var currentHandle = root.getAttribute('data-current-handle');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;

    if(currentHandle){ trackHandle(currentHandle); }

    var handles = getHandles().filter(function(h){ return h !== currentHandle; }).slice(0, limit);
    if(!handles.length) return;

    Promise.all(handles.map(function(handle){
      return fetch('/products/' + handle + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    })).then(function(products){
      products = products.filter(Boolean);
      if(!products.length) return;
      products.forEach(function(p){ grid.appendChild(buildCard(p)); });
      root.hidden = false;
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
